module.exports = __webpack_public_path__ + "static/media/Y11.21f76152.mp3";